import { render, staticRenderFns, recyclableRender, components } from "./u--image.vue?vue&type=template&id=55e644e9&"
var renderjs
import script from "./u--image.vue?vue&type=script&lang=js&"
export * from "./u--image.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../HBuilderX.3.8.4.20230531/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null,
  false,
  components,
  renderjs
)

component.options.__file = "uni_modules/uview-ui/components/u--image/u--image.vue"
export default component.exports